import React from "react";
import { cn } from "../../../utils/tw";
import { theme } from "../../../theme/tokens";

type ButtonVariant = "primary" | "secondary" | "ghost" | "icon";

type ButtonSize = "sm" | "md" | "lg";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
}

const baseStyles =
  "inline-flex items-center justify-center font-semibold transition disabled:opacity-60 disabled:cursor-not-allowed";

const variantStyles: Record<ButtonVariant, React.CSSProperties> = {
  primary: { backgroundColor: theme.colors.primary, color: theme.colors.background },
  secondary: { backgroundColor: theme.colors.secondary, color: theme.colors.primary },
  ghost: { backgroundColor: "transparent", color: theme.colors.primary },
  icon: { backgroundColor: "transparent", color: theme.colors.primary, padding: theme.spacing.sm },
};

const variants: Record<ButtonVariant, string> = {
  primary: "hover:bg-primary/90",
  secondary: "hover:bg-secondary/90",
  ghost: "hover:bg-primary/10",
  icon: "hover:bg-primary/10",
};

const sizes: Record<ButtonSize, string> = {
  sm: "text-sm px-2 py-1",
  md: "text-sm px-4 py-2",
  lg: "text-base px-6 py-3",
};

export const Button: React.FC<ButtonProps> = ({
  variant = "primary",
  size = "md",
  loading,
  className,
  children,
  ...props
}) => (
  <button
    className={cn(baseStyles, variants[variant], sizes[size], className)}
    style={{ borderRadius: theme.radius.md, ...variantStyles[variant] }}
    disabled={loading || props.disabled}
    {...props}
  >
    {loading ? <span className="loader" /> : children}
  </button>
);

export default Button;
